import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { HydratedRouter } from "react-router/dom";
import "./i18n.ts"; // Import i18n configuration
import "./index.css";

createRoot(document).render(
  <StrictMode>
    <HydratedRouter />
  </StrictMode>,
);
